
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowBidirectionalVertical as ObiArrowBidirectionalVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-bidirectional-vertical.js';
 
 
 

 
 export const ObiArrowBidirectionalVertical = createComponent({
   react: React,
   tagName: 'obi-arrow-bidirectional-vertical',
   elementClass: ObiArrowBidirectionalVerticalElement,
   events: {
     
   }
  });
 
 